@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

@border: var(--default--border-color--6) solid 1px;

.upsell-modal-layout {
  display: flex;
  align-items: stretch;
  height: 696px;
  min-height: min-content;
}

.modal-header {
  background-color: transparent;
  box-shadow: none;
  width: 100%;
  position: absolute;
}

.description-wrapper {
  display: flex;
  background-color: var(--light--background-color--1);
  flex-direction: column;
  justify-content: space-between;
  flex: 2;

  .description {
    padding: @space-32;
  }
}

.description-footer {
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  width: 100%;
  padding: @space-24 @space-32;
  border-top: @border;
  box-shadow: 0 -4px 8px -2px var(--black-fade-5);
}
